export default __webpack_public_path__ + "static/media/ico-chevron-reg-down.61568713.svg";